import { InternetStatusType } from '@/types/internet/InternetType'
import { Translator } from '../../types/ApiResponseTypes'
import { parseIsoDateTime } from '../../utils/common'
import { InternetStatusResponseType, isInternetStatusResponseType } from '@/types/internet/InternetResponseType'

class InternetStatusResponseTranslator implements Translator<InternetStatusType> {
  convert(response: any): InternetStatusType {
    if (isInternetStatusResponseType(response)) {
      if (Array.isArray(response)) {
        return this.converToStatusModel(response[0])
      } else {
        return this.converToStatusModel(response)
      }
    }
    return {} as InternetStatusType
  }

  converToStatusModel(statusresponse: InternetStatusResponseType): InternetStatusType {
    return {
      status: statusresponse.status ?? '',
      ipAddress: statusresponse.ipAddress ?? '',
      startTime: parseIsoDateTime(statusresponse.startTime) ?? '',
      stopTime: statusresponse.stopTime == null ? '' : parseIsoDateTime(statusresponse.startTime),
      callerId: statusresponse.callerId ?? '',
      terminationCause: statusresponse.terminationCause ?? '',
      uploadSpeed: statusresponse.uploadSpeed ?? 0,
      downloadSpeed: statusresponse.downloadSpeed ?? 0,
      usage: {
        up: statusresponse.usage.up ?? 0,
        down: statusresponse.usage.down ?? 0,
      },
    }
  }
}
export default new InternetStatusResponseTranslator()
